
export default (props) => {
  return `
    background-color: rgba(255, 255, 255, 1);
    border-radius: 0.5rem;
    font-size: 1.4rem;
    color: rgba(111, 88, 255, 1);
    font-weight: 400;
    left: 1.5rem;
    top: 1.5rem;
    padding: 0.5rem;
    border-radius: 0.4rem;
    box-shadow: 0 3px 6px 2px rgba(39, 39, 39, 0.05);
    display: inline-block;
    min-width: fit-content;


    svg {
      width: 3rem;
      height: 3rem;
      top: 0.25rem;
      position: relative;
    }

    ${typeof props === 'string' ? props : ''}
  `
};

